var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-record" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c(
              "el-form",
              {
                ref: "queryForm",
                attrs: {
                  model: _vm.queryParams,
                  "label-width": "80px",
                  size: "small",
                  inline: "",
                },
              },
              [
                _c("div", { staticClass: "filter-form" }, [
                  _c(
                    "div",
                    { staticClass: "filter-default" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "反馈用户" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系方式",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.contact,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "contact", $$v)
                              },
                              expression: "queryParams.contact",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "代理商" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请搜索并选择代理商",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.handleAgentSearch,
                                loading: false,
                                "reserve-keyword": "",
                                debounce: 0,
                              },
                              model: {
                                value: _vm.queryParams.aid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "aid", $$v)
                                },
                                expression: "queryParams.aid",
                              },
                            },
                            _vm._l(_vm.agentList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商户地址" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请搜索并选择商户地址",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.handleStoreSearch,
                                loading: false,
                                "reserve-keyword": "",
                                debounce: 0,
                              },
                              model: {
                                value: _vm.queryParams.store_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "store_id", $$v)
                                },
                                expression: "queryParams.store_id",
                              },
                            },
                            _vm._l(_vm.storeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.store_name,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "问题类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择问题类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.record_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "record_type", $$v)
                                },
                                expression: "queryParams.record_type",
                              },
                            },
                            _vm._l(_vm.recordTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "设备类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择设备类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.goods_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "goods_type", $$v)
                                },
                                expression: "queryParams.goods_type",
                              },
                            },
                            _vm._l(_vm.goodsTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMoreFilter,
                          expression: "showMoreFilter",
                        },
                      ],
                      staticClass: "filter-more",
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "设备SN号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入设备SN号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.goods_sn,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "goods_sn", $$v)
                              },
                              expression: "queryParams.goods_sn",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择处理状态",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "status", $$v)
                                },
                                expression: "queryParams.status",
                              },
                            },
                            _vm._l(_vm.statusOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "登记人员" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入登记人员",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.add_person,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "add_person", $$v)
                              },
                              expression: "queryParams.add_person",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "添加时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              type: "daterange",
                              "range-separator": "|",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.add_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "add_date", $$v)
                              },
                              expression: "queryParams.add_date",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "内容" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入内容关键字",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "content", $$v)
                              },
                              expression: "queryParams.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-buttons" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleFilter },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c("el-button", { on: { click: _vm.resetQuery } }, [
                            _vm._v("重置"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleCreate },
                            },
                            [_vm._v("创建")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.showMoreFilter = !_vm.showMoreFilter
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.showMoreFilter ? "收起" : "更多") +
                                  "\n                  "
                              ),
                              _c("i", {
                                class: _vm.showMoreFilter
                                  ? "el-icon-arrow-up"
                                  : "el-icon-arrow-down",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.recordList, border: "", height: 500 },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "contact", label: "反馈用户", width: "120" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "admin_user_name",
                    label: "所属代理",
                    width: "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "store_name",
                    label: "商户地址",
                    width: "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goods_type_name",
                    label: "设备类型",
                    width: "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "record_type_name",
                    label: "问题类型",
                    width: "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "content", label: "跟进内容", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: scope.row.content,
                                placement: "top",
                                "popper-class": "content-tooltip",
                              },
                            },
                            [
                              _c("div", { staticClass: "content-cell" }, [
                                _vm._v(_vm._s(scope.row.content)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "record", label: "跟进记录" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: scope.row.record,
                                placement: "top",
                                "popper-class": "content-tooltip",
                              },
                            },
                            [
                              _c("div", { staticClass: "content-cell" }, [
                                _vm._v(_vm._s(scope.row.record)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "record_status_name",
                    label: "跟进状态",
                    width: "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "add_person",
                    label: "登记人员",
                    width: "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "add_date", label: "添加时间", width: "180" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "图片", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.img_list && scope.row.img_list.length > 0
                            ? _c(
                                "div",
                                { staticClass: "image-preview-container" },
                                _vm._l(
                                  scope.row.img_list,
                                  function (img, index) {
                                    return _c(
                                      "el-image",
                                      {
                                        key: index,
                                        staticClass: "image-preview",
                                        attrs: {
                                          src: img,
                                          fit: "cover",
                                          "preview-src-list":
                                            scope.row.img_list,
                                          lazy: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-slot",
                                            attrs: { slot: "error" },
                                            slot: "error",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-picture-outline",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _c("span", [_vm._v("无图片")]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "215", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "ml-0",
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleView(scope.row)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "跟进记录详情",
            visible: _vm.dialogVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "detail-form",
              attrs: { model: _vm.currentRecord, "label-width": "150px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "ID" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.currentRecord.id))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进用户联系方式" } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.currentRecord.contact)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "跟进所属代理" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.admin_user_name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "商户地址" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.store_name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "设备SN号" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.goods_sn)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "设备类型" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.goods_type_name)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "问题类型" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.record_type_name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "处理状态" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.record_status_name)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "登记人员" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.add_person)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "添加时间" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.add_date)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "更新时间" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.currentRecord.upd_date)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "跟进内容" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.currentRecord.content))]),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "跟进记录" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.currentRecord.record))]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentRecord.img_list &&
              _vm.currentRecord.img_list.length > 0
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "图片" } }, [
                            _c(
                              "div",
                              { staticClass: "image-detail-container" },
                              _vm._l(
                                _vm.currentRecord.img_list,
                                function (img, index) {
                                  return _c(
                                    "el-image",
                                    {
                                      key: index,
                                      staticClass: "image-detail",
                                      attrs: {
                                        src: img,
                                        fit: "cover",
                                        "preview-src-list":
                                          _vm.currentRecord.img_list,
                                        lazy: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "image-slot",
                                          attrs: { slot: "error" },
                                          slot: "error",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit ? "编辑跟进记录" : "新建跟进记录",
            visible: _vm.createDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: { model: _vm.createForm, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户联系方式", prop: "contact" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入用户联系方式" },
                            model: {
                              value: _vm.createForm.contact,
                              callback: function ($$v) {
                                _vm.$set(_vm.createForm, "contact", $$v)
                              },
                              expression: "createForm.contact",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属代理", prop: "aid" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请搜索并选择所属代理",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.handleAgentSearch,
                                loading: false,
                                "reserve-keyword": "",
                                debounce: 0,
                              },
                              model: {
                                value: _vm.createForm.aid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.createForm, "aid", $$v)
                                },
                                expression: "createForm.aid",
                              },
                            },
                            _vm._l(_vm.agentList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商户地址", prop: "store_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请搜索并选择商户地址",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.handleStoreSearch,
                                loading: false,
                                "reserve-keyword": "",
                                debounce: 0,
                              },
                              model: {
                                value: _vm.createForm.store_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.createForm, "store_id", $$v)
                                },
                                expression: "createForm.store_id",
                              },
                            },
                            _vm._l(_vm.storeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.store_name,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "设备SN号", prop: "goods_sn" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入设备SN号" },
                            model: {
                              value: _vm.createForm.goods_sn,
                              callback: function ($$v) {
                                _vm.$set(_vm.createForm, "goods_sn", $$v)
                              },
                              expression: "createForm.goods_sn",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "设备类型", prop: "goods_type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择设备类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.createForm.goods_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.createForm, "goods_type", $$v)
                                },
                                expression: "createForm.goods_type",
                              },
                            },
                            _vm._l(_vm.goodsTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "问题类型", prop: "record_type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择问题类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.createForm.record_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.createForm, "record_type", $$v)
                                },
                                expression: "createForm.record_type",
                              },
                            },
                            _vm._l(_vm.recordTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进状态", prop: "status" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择处理状态",
                                clearable: "",
                              },
                              model: {
                                value: _vm.createForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.createForm, "status", $$v)
                                },
                                expression: "createForm.status",
                              },
                            },
                            _vm._l(_vm.statusOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "登记人员", prop: "add_person" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入登记人员" },
                            model: {
                              value: _vm.createForm.add_person,
                              callback: function ($$v) {
                                _vm.$set(_vm.createForm, "add_person", $$v)
                              },
                              expression: "createForm.add_person",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进内容", prop: "content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入跟进内容",
                              rows: 4,
                            },
                            model: {
                              value: _vm.createForm.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.createForm, "content", $$v)
                              },
                              expression: "createForm.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "跟进记录", prop: "record" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入跟进内容",
                              rows: 4,
                            },
                            model: {
                              value: _vm.createForm.record,
                              callback: function ($$v) {
                                _vm.$set(_vm.createForm, "record", $$v)
                              },
                              expression: "createForm.record",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "图片上传" } },
                        [
                          _c(
                            "div",
                            { staticClass: "upload-container" },
                            [
                              _vm.fileList.length < 5
                                ? _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: _vm.uploadUrl,
                                        "list-type": "picture-card",
                                        "on-preview":
                                          _vm.handlePictureCardPreview,
                                        "on-remove": _vm.handleRemove,
                                        "on-success": _vm.handleUploadSuccess,
                                        "on-error": _vm.handleUploadError,
                                        "file-list": _vm.fileList,
                                        "before-upload": _vm.beforeUpload,
                                        name: "file",
                                        multiple: "",
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "uploaded-images" },
                                    _vm._l(
                                      _vm.fileList,
                                      function (file, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "uploaded-image-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePictureCardPreview(
                                                  file
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "uploaded-image",
                                              attrs: { src: file.url },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v(
                              "最多可上传5张图片，已上传" +
                                _vm._s(_vm.fileList.length) +
                                "/5张"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-dialog",
                            {
                              attrs: {
                                visible: _vm.dialogVisiblePreview,
                                "append-to-body": "",
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisiblePreview = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancelOrBack } }, [
                _vm._v(_vm._s(_vm.fromPageCall ? "返 回" : "取 消")),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitCreateForm },
                },
                [_vm._v(_vm._s(_vm.isEdit ? "更 新" : "提交"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }